import { PureComponent } from 'react';
import { connect } from 'react-redux';
import ReactPlayer from 'react-player';
import { Alert, OverlayTrigger, Popover } from 'react-bootstrap';
import Truncate from 'react-truncate';
import {
  setPlayerFlag,
  setPlayerDocument,
  setIsPaused,
  setDisableSkipAheadButton,
  setDisableSkipBackButton,
  updatePollyPlayerSkipButton
} from '../../../redux/actions/player-actions';
import { convertSecondsToTime } from '../../../utils/utils';
import { ReactComponent as PlayButtonSvg } from '../../../images/dashboard-player-play-btn.svg';
import { ReactComponent as VolumeButtonSvg } from '../../../images/dashboard-player-volume-btn.svg';
import Slider from 'rc-slider';

require('../styles/media-player.css');

class FlagsMediaPlayer extends PureComponent {
  static defaultProps = {
    onPlay: () => {},
    onPause: () => {},
    onProgress: () => {}
  };

  constructor(props) {
    super(props);

    this.state = {
      play: false,
      message: null,
      error: false,
      cantPlay: false,
      showAlertAudio: false,
      numOfFlag: 1,
      playbackRate: this.setPlaybackRate(),
      progress: 0,
      displayVolume: false,
      volume: 0.5,
      muted: false,
      showSpeedControl: false
    };
  }

  ref = (flagsPlayer) => (this.flagsPlayer = flagsPlayer);

  componentDidMount() {
    if (this.props.playerFlag && this.props.playerFlag.url === '') {
      this.handleError();
    } else {
      if (this.flagsPlayer) {
        this.flagsPlayer.seekTo(-1);
      }
    }
  }

  componentWillUnmount() {
    clearTimeout(this.interval);
  }

  componentDidUpdate(prevProps) {
    if (this.state.error && this.state.showAlertAudio) {
      console.log('ERROR IN POLLY CAUSE TIMING');
      this.setState({
        message:
          "Audio fragment is not available any more. Please press 'Play selected'."
      });
    } else {
      if (this.props.playerFlag && this.props.playerFlag.url !== '') {
        this.interval = setTimeout(() => {
          this.setState({
            showAlertAudio: false,
            error: false,
            message: null
          });
        }, 1);
      }

      if (this.props.playbackFlags.length === 1) {
        this.props.dispatch(updatePollyPlayerSkipButton(false));
        this.props.dispatch(updatePollyPlayerSkipButton(false));
      } else {
        this.props.dispatch(updatePollyPlayerSkipButton(true));
        this.props.dispatch(updatePollyPlayerSkipButton(true));
      }

      if (
        prevProps.playerFlag &&
        prevProps.playerFlag.document !== this.props.playerFlag.document &&
        !this.props.isSelectedFlags
      ) {
        this.setState({ numOfFlag: 1 });
        this.setState({ progress: 0 });
      }

      if (this.flagsPlayer) {
        let currentIndex = 0;
        let currentFlag = this.props.playerFlag;
        let flags = this.props.playbackFlags;
        currentIndex = flags.findIndex((f) => f.id === currentFlag.id);

        if (currentIndex >= 0) {
          if (currentIndex - 1 < 0) {
            this.props.dispatch(setDisableSkipBackButton(true));
          } else {
            this.props.dispatch(setDisableSkipBackButton(false));
          }

          if (currentIndex + 1 > this.props.playbackFlags.length - 1) {
            this.props.dispatch(setDisableSkipAheadButton(true));
          } else {
            this.props.dispatch(setDisableSkipAheadButton(false));
          }
        }

        if (
          this.flagsPlayer.getCurrentTime() !== null &&
          this.flagsPlayer.getCurrentTime() == this.flagsPlayer.getDuration()
        ) {
          let currentIndex = 0;
          let currentFlag = this.props.playerFlag;
          let flags = this.props.playbackFlags;
          currentIndex = flags.findIndex((f) => f.id === currentFlag.id);

          if (currentIndex === flags.length - 2) {
            this.props.dispatch(setDisableSkipAheadButton(true));
          }
          let nextFlag = flags[currentIndex + 1];
          if (nextFlag) {
            this.setState({ numOfFlag: currentIndex + 2 });
            this.props.dispatch(setPlayerFlag(nextFlag));
            this.props.dispatch(setIsPaused(false));
            this.flagsPlayer.seekTo(-1);
          }
        }
      }

      if (this.props.playerFlag && this.props.playerFlag.url === '') {
        this.handleError();
      }
    }
  }

  handleDismiss = () => {
    this.setState({ showAlertAudio: false });
    this.setState({ error: false });
    this.setState({ message: null });
  };

  handleStart = () => {
    this.setState({ progress: 0 });
    this.props.dispatch(setPlayerDocument(''));
    this.flagsPlayer.seekTo(this.state.progress);
  };

  handlePlay = () => {
    this.props.dispatch(setIsPaused(false));
    this.setState({ play: true });
    //this.flagsPlayer.seekTo(this.state.progress)
  };

  handlePause = () => {
    this.props.dispatch(setIsPaused(true));
    this.setState({ play: false });
  };

  handleProgress = (flag) => {
    const progress = parseInt(flag.playedSeconds, 10);
    this.setState({ progress });
  };

  handleError = () => {
    this.setState({
      showAlertAudio: true,
      error: true,
      cantPlay: true,
      play: false,
      message: 'Audio fragment is not available for playback'
    });
  };

  forward = () => {
    this.props.dispatch(setDisableSkipBackButton(false));
    let currentIndex = 0;
    let currentFlag = this.props.playerFlag;
    let flags = this.props.playbackFlags;

    currentIndex = flags.findIndex((f) => f.id === currentFlag.id);
    this.setState({ numOfFlag: currentIndex + 2 });
    if (currentIndex === flags.length - 2) {
      this.props.dispatch(setDisableSkipAheadButton(true));
    }
    let nextFlag = flags[currentIndex + 1];
    this.props.dispatch(setPlayerFlag(nextFlag));
    this.props.dispatch(setIsPaused(false));
    this.flagsPlayer.seekTo(-1);
    this.setState({ progress: 0 });
  };

  backward = () => {
    this.props.dispatch(setDisableSkipAheadButton(false));
    let currentIndex = 0;
    let currentFlag = this.props.playerFlag;
    let flags = this.props.playbackFlags;

    currentIndex = flags.findIndex((f) => f.id === currentFlag.id);
    this.setState({ numOfFlag: currentIndex });
    let previousFlag = flags[currentIndex - 1];
    if (currentIndex === 1) {
      this.props.dispatch(setDisableSkipBackButton(true));
    }
    this.props.dispatch(setPlayerFlag(previousFlag));
    this.props.dispatch(setIsPaused(false));
    this.flagsPlayer.seekTo(-1);
    this.setState({ progress: 0 });
  };

  setPlaybackRate = () => {
    const userPlaybackRate = localStorage.getItem('userPlaybackRate');
    return userPlaybackRate != null ? parseFloat(userPlaybackRate) : 1;
  };

  onSliderChange = (value) => {
    this.setState({ playbackRate: value });
    localStorage.setItem('userPlaybackRate', value);
  };

  handleClickButtonVolume = () => {
    this.state.muted
      ? this.setState({ muted: false, volume: 0.5 })
      : this.setState({ muted: true, volume: 0 });
  };

  handleVolumeChange = (value) => {
    this.setState({ volume: value });
  };

  handleProgressChange = (event) => {
    const seekTo = parseFloat(event.target.value);
    this.flagsPlayer?.seekTo(seekTo);
    this.setState({ progress: seekTo });
  };

  render() {
    const playerFlag = this.props.playerFlag;
    const crt = this.state.progress;
    const displayVolume = this.state.displayVolume ? 'block' : 'none';
    const showPollyPlayerSkipButton = this.props.showPollyPlayerSkipButton;

    if (playerFlag === '' || !playerFlag) {
      return <></>;
    }

    return (
      <>
        <div className="media-player-container">
          <div>
            <button
              title="Close player"
              type="button"
              className="close-player-button align-left"
              onClick={() => {
                this.props.dispatch(setPlayerFlag(''));
              }}
            >
              x
            </button>
          </div>
          <div className="player-container" style={{ height: '100%' }}>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                height: '100%',
                marginRight: '15px',
                marginLeft: '15px',
                gap: '4px',
                margin: '4px 8px'
              }}
            >
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center'
                }}
              >
                <OverlayTrigger
                  style={{ zindex: 9999999 }}
                  trigger={['hover', 'focus']}
                  placement="bottom"
                  overlay={
                    <Popover id="popover-basic">
                      {playerFlag.podcast + ' / ' + playerFlag.document}
                    </Popover>
                  }
                >
                  <Truncate lines={1} ellipsis={'...'} width={400}>
                    {playerFlag.podcast + ' / ' + playerFlag.document}
                  </Truncate>
                </OverlayTrigger>
              </div>
              {this.props.playbackFlags.length > 1 && (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    fontSize: '12px'
                  }}
                >
                  Flag {this.state.numOfFlag} of{' '}
                  {this.props.playbackFlags.length}
                </div>
              )}
            </div>
            <ReactPlayer
              ref={this.ref}
              url={playerFlag.url}
              height="45px"
              width="5px"
              playing={this.state.play}
              playbackRate={this.state.playbackRate}
              onReady={() => this.setState({ play: true })}
              onStart={this.handleStart}
              onPause={this.handlePause}
              onProgress={this.handleProgress}
              onPlay={this.handlePlay}
              onEnded={() => this.setState({ play: false })}
              onError={this.handleError}
              volume={this.state.volume}
              muted={this.state.muted}
            />
            <div
              style={{
                maxWidth: '50%',
                minWidth: '50%',
                height: '45px',
                backgroundColor: '#1A1A1E',
                border: '1px solid black',
                borderRadius: '5px'
              }}
            >
              <div className="player-controls-container">
                <button
                  style={{ marginLeft: '10px' }}
                  className="btn-svg"
                  onClick={this.state.play ? this.handlePause : this.handlePlay}
                >
                  {this.state.play ? (
                    <i className="fa fa-pause"></i>
                  ) : (
                    <PlayButtonSvg width="14px" />
                  )}
                </button>
                <div className="previous-next-controls">
                  <div>
                    <button
                      title="Previous flag"
                      type="button"
                      className="btn-svg"
                      style={{
                        visibility: showPollyPlayerSkipButton
                          ? 'visible'
                          : 'hidden'
                      }}
                      disabled={this.props.disableSkipBackButton ? true : false}
                      onClick={() => this.backward()}
                    >
                      <i
                        className="fa fa-backward"
                        style={{ padding: '8px' }}
                        aria-hidden="true"
                      ></i>
                    </button>
                  </div>
                </div>
                <div className="player-number">
                  {crt != null && !isNaN(crt)
                    ? convertSecondsToTime(crt)
                    : '00:00'
                  }
                </div>
                <input
                  type="range"
                  min={0}
                  max={15}
                  step={0.1}
                  value={this.state.progress}
                  onChange={this.handleProgressChange}
                  className="progress-bar1"
                />
                {/*<div className="player-number">{duration!==undefined && duration!==null && !isNaN(duration) && duration!==Infinity ? convertSecondsToTime(duration) : ''}</div>*/}
                <div className="previous-next-controls">
                  <div>
                    <button
                      title="Next flag"
                      type="button"
                      className="btn-svg"
                      style={{
                        visibility: showPollyPlayerSkipButton
                          ? 'visible'
                          : 'hidden'
                      }}
                      disabled={
                        this.props.disableSkipAheadButton ? true : false
                      }
                      onClick={() => this.forward()}
                    >
                      <i
                        className="fa fa-forward"
                        style={{ padding: '8px' }}
                        aria-hidden="true"
                      ></i>
                    </button>
                  </div>
                </div>
                <div className="flex-container-volume">
                  <div
                    className="flex-container"
                    onMouseEnter={() => this.setState({ displayVolume: true })}
                    onMouseLeave={() => this.setState({ displayVolume: false })}
                  >
                    <button
                      type="button"
                      className="btn-svg"
                      style={{ alignItems: 'center' }}
                      onClick={this.handleClickButtonVolume}
                    >
                      {this.state.muted ? (
                        <i
                          className="fa fa-volume-off fa-2x"
                          aria-hidden="true"
                          style={{ marginLeft: '5px' }}
                        ></i>
                      ) : (
                        <VolumeButtonSvg width="30px" />
                      )}
                    </button>
                    <div
                      className="volumemeter"
                      style={{
                        display: displayVolume,
                        alignItems: 'center',
                        marginRight: displayVolume ? '15px' : '0'
                      }}
                    >
                      <Slider
                        vertical
                        min={0}
                        max={1}
                        value={this.state.volume}
                        marks={{ 0.0: 0.0, 1.0: 1.0 }}
                        step={0.01}
                        onChange={this.handleVolumeChange}
                      />
                    </div>
                  </div>
                  <div
                    className="flex-container"
                    onMouseEnter={() =>
                      this.setState({ showSpeedControl: true })
                    }
                    onMouseLeave={() =>
                      this.setState({ showSpeedControl: false })
                    }
                  >
                    <button
                      title="Change playback speed"
                      type="button"
                      className="btn-svg"
                    >
                      <div className="player-number">
                        {this.state.playbackRate}x
                      </div>
                    </button>
                    {this.state.showSpeedControl && (
                      <div
                        className="speedometer1"
                        style={{ display: 'flex', alignItems: 'center' }}
                      >
                        <Slider
                          vertical
                          min={0.5}
                          max={2.5}
                          value={this.state.playbackRate}
                          marks={{ 0.5: 0.5, 2.5: 2.5 }}
                          step={0.1}
                          onChange={this.onSliderChange}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            {this.state.showAlertAudio && (
              <div
                style={{
                  position: 'absolute',
                  top: '90%',
                  right: '30%'
                }}
              >
                <Alert
                  bsStyle={this.state.error ? 'warning' : 'success'}
                  onDismiss={this.handleDismiss}
                >
                  <h4>Warning!</h4>
                  <p>{this.state.message}</p>
                </Alert>
              </div>
            )}
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (store) => {
  return {
    playerFlag: store.player.playerFlag,
    disableSkipAheadButton: store.player.disableSkipAheadButton,
    disableSkipBackButton: store.player.disableSkipBackButton,
    forward: store.player.forward,
    backward: store.player.backward,
    playbackFlags: store.app.playbackFlags,
    playerDocument: store.player.playerDocument,
    isSelectedFlags: store.player.isSelectedFlags,
    showPollyPlayerSkipButton: store.player.showPollyPlayerSkipButton
  };
};

export default connect(mapStateToProps)(FlagsMediaPlayer);
